import * as React from 'react';
import { Paragraph2 } from '@cian/ui-kit';

import { Stars, TSize } from '../packages/Stars';

import * as styles from './styles.css';

interface IRatingProps {
  text?: string;
  value: number;
  size?: TSize;
}

export const Rating = ({ text, value, size }: IRatingProps) => {
  return (
    <div className={styles['rating']}>
      <Stars size={size} uniqueKey={'rating'} value={value} />
      {text && (
        <div className={styles['rating-desctiption']}>
          <Paragraph2>{text}</Paragraph2>
        </div>
      )}
    </div>
  );
};
